<template>
  <div class="header-wrap">
    <div class="title">{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
};
</script>
<style lang="less" scoped>
  .header-wrap {
    display: flex;
    background-image: url("../../../../static/img/navTitleBg.png");
    justify-content: space-between;
    background-size: 100% 100%;
    width: 100%;
    max-width: 280px;
    height: 40px;
  }

  .title {
    line-height: 40px;
    font-size: 18px;
    color: #CEF2FF;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding-left: 15%;
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/studio/homepage/home/title.vue